import * as R from 'remeda';
import { ToroEnvironment, toroEnvironment } from '@repo/common/config';

const currentEnvironmentName = toroEnvironment || 'dev';
const isLocal = currentEnvironmentName === 'local';

const isServer = Boolean(typeof window === 'undefined');
const proxyBackendEnabled = Boolean(process.env.NEXT_PUBLIC_PROXY_BACKEND);
const proxyBackendUrl = proxyBackendEnabled && !isServer ? '/api/backend' : null;

// Parse env variables into boolean or null
const parseBool = (val?: string | boolean | null): boolean | null => {
  if (R.isBoolean(val)) {
    return !!val;
  } else if (R.isString(val)) {
    switch (val.trim().toLowerCase()) {
      case 'true':
        return true;
      case 'false':
        return false;
      case '':
        return null;
      default: {
        console.error(`Invalid value for boolean env variable: "${val}"`);
        return null;
      }
    }
  } else {
    return null;
  }
};

export const vercelToolbarEnabled = parseBool(process.env.NEXT_PUBLIC_VERCEL_TOOLBAR) ?? false;
// Enabled in local env by default
export const reactQueryDebuggerEnabled =
  parseBool(process.env.NEXT_PUBLIC_DEBUG_REACT_QUERY) ?? isLocal;

interface ApiEnvironmentConfig {
  label: string;
  id: string;
  baseUrl: string;
}

const ENV_CONFIGS = {
  local: {
    id: 'local',
    label: 'Local',
    baseUrl: proxyBackendUrl || 'http://localhost:8080',
  },
  dev: {
    id: 'dev',
    label: 'Dev',
    baseUrl: proxyBackendUrl || 'https://dev-api.toroinsights.ai',
  },
  prod: {
    id: 'prod',
    label: 'Prod',
    baseUrl: proxyBackendUrl || 'https://api.toroinsights.ai',
  },
  test: {
    id: 'test',
    label: 'Test',
    baseUrl: proxyBackendUrl || 'http://localhost:8080',
  },
} as const satisfies Record<ToroEnvironment, ApiEnvironmentConfig>;

export const allApiEnvironments = R.values(ENV_CONFIGS);

export const apiEnvironment = ENV_CONFIGS[currentEnvironmentName];
export default apiEnvironment;
